import './timeline-slider.scss'
import { loadSvg } from 'js/utility/image.js'

export default {
    name: 'timeline-slider',

    data: {
        index: 0,
        timeout: null
    },

    computed: {
        sliderTransform() {
            if (this.items && this.items.length) {
                return `translateX(${(100 / this.items.length) * -this.index}%)`
            } else {
                return 'none'
            }
        }
    },

    watch: {
        index () {
            this.sliderTimeout()
        }
    },

    mounted () {
        this.loadIcons()
        this.sliderTimeout()
    },

    methods: {
        loadIcons () {
            this.items.forEach(item => {
                if (item.icon_url) {
                    loadSvg(item.icon_url).then(svg => item.icon_svg = svg.outerHTML)
                }
            })
        },

        next () {
            if (this.index + 1 === this.items.length) {
                return
            } else {
                this.index++
            }
        },

        prev () {
            if (this.index - 1 < 0) {
                return
            } else {
                this.index--
            }
        },

        sliderTimeout () {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                if (this.index + 1 === this.items.length) {
                    this.index = 0
                } else {
                    this.index++
                }
            }, 8000)
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/timeline-slider/timeline-slider.js